import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SearchButton } from 'components/styled/ui';
import { connect } from 'react-redux';
import { getData, dataReceived } from 'datahub/actions';
import { setSearch, setCategories, setPublishedDates } from 'filters/actions';
import dataService from 'api/dataService';
import { filterData, resetCategories } from 'filters/selectors';
import { images, strings } from 'config';

class Search extends Component {
  constructor() {
    super();
    this.state = {
      searchTerm: '',
      isSearching: false,
      searchOpen: false
    };
  }

  static defaultProps = {
    placeholder: 'Search'
  };

  static propTypes = {
    placeholder: PropTypes.string
  };

  componentWillReceiveProps(nextProps) {
    const { filters } = nextProps;
    this._inputValue.value = filters.search;

    if (!filters.search) {
      this.setState({
        isSearching: false
      });
    }
  }

  searchToggle = () => {
    this.setState(
      {
        searchOpen: !this.state.searchOpen
      },
      () => {
        this.props.isSearchOpenMob(this.state.searchOpen);
      }
    );
  };

  handleKeyPress = e => {
    if (e.key === 'Enter') {
      const inputValue = this._inputValue.value;
      this.handleSearch(inputValue);
    }
  };

  handleKeyPressMob = e => {
    if (e.key === 'Enter') {
      const inputValue = this._inputValueMob.value;
      this.handleSearch(inputValue);
    }
  };

  handleSearchButton = () => {
    const inputValue = this._inputValue.value;
    this.handleSearch(inputValue);
  };

  handleSearch = input => {
    this.handleSearchSubmit(input);
  };

  handleSearchSubmit = searchTerm => {
    const { filters, handleFilters } = this.props;
    const initialCategories = resetCategories(filters.categories);
    const initialPublishedDates = [];
    const initialdocumentSources = {
      label: '',
      value: ''
    };
    const initialdocumentTypes = {
      label: '',
      value: ''
    };
    const filteredResult = {
      ...filters,
      ...{
        search: searchTerm,
        categories: initialCategories,
        publishedDates: initialPublishedDates,
        documentTypes: initialdocumentTypes,
        documentSources: initialdocumentSources,
        page: 1
      }
    };

    this._inputValue.value = '';
    handleFilters(filteredResult);
    this.props.history.push('/');
  };

  resetSearch = () => {
    const { filters, handleFilters } = this.props;
    const initialCategories = resetCategories(filters.categories);
    const initialPublishedDates = [];
    const filteredResult = {
      ...filters,
      ...{
        search: '',
        categories: initialCategories,
        publishedDates: initialPublishedDates,
        page: 1
      }
    };

    this._inputValue.value = '';
    this._inputValueMob.value = '';

    this.setState({
      isSearching: false
    });

    handleFilters(filteredResult);
  };

  handleSearching = e => {
    if (e.target.value.length) {
      this.setState({
        isSearching: true
      });
    } else {
      this.setState({
        isSearching: false
      });
    }
  };

  renderDesktop() {
    const { placeholder } = this.props;
    const { isSearching } = this.state;

    return (
      <SearchBox className="search" icon={images.icons.search} lang={strings.getLanguage()}>
        <input
          type="text"
          placeholder={placeholder}
          className="input"
          icon={images.icons.search}
          ref={input => (this._inputValue = input)}
          onKeyPress={this.handleKeyPress}
          onChange={this.handleSearching}
        />

        <div className="actions">
          {isSearching && <CloseIcon onClick={this.resetSearch} light />}
          <SearchButton onClick={this.handleSearchButton}>{strings.search.search}</SearchButton>
        </div>
      </SearchBox>
    );
  }

  renderMob() {
    const { searchOpen } = this.state;
    const { isContactOpen } = this.props;

    if (!isContactOpen) {
      return (
        <SearchMobile icon={images.icons.searchSmallBlue}>
          <div className="search-toggle" onClick={this.searchToggle}>
            <img
              src={searchOpen ? images.icons.cross : images.icons.searchSmall}
              alt="search icon"
            />
          </div>
          <div className={this.state.searchOpen ? 'search-input is-active' : 'search-input'}>
            <input
              type="text"
              placeholder={strings.search.placeholder}
              className="input"
              ref={input => (this._inputValueMob = input)}
              onKeyPress={this.handleKeyPressMob}
              onChange={this.handleSearching}
            />
            <CloseIcon onClick={this.searchToggle} />
          </div>
        </SearchMobile>
      );
    }
  }

  render() {
    return (
      <Fragment>
        {this.renderMob()}
        {this.renderDesktop()}
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    filters: state.filters
  };
};

const mapDispatchToProps = dispatch => {
  return {
    handleFilters: filters => {
      dispatch(setSearch(filters.search));
      dispatch(setCategories(filters.categories));
      dispatch(setPublishedDates(filters.publishedDates));
      dispatch(getData());
      const queryParams = filterData(filters);
      dataService.getDataList(queryParams).then(response => {
        dispatch(dataReceived(response));
      });
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Search));

const SearchBox = styled.div`
  position: relative;

  @media screen and (max-width: 768px) {
    display: none;
  }

  input{
    position: relative;
    background-image: url('${props => props.icon}');
    background-size: 16px;
    width: 385px;
    height: 48px;
    background-color: transparent;
    color: #fff;
    font-size: 14px;
    line-height: 22px;
    text-indent: 47px;
    background-repeat: no-repeat;
    background-position: 20px center;
    border-radius: 24px;
    border: 1px solid #f0f8ff;
    outline: none;
    width: 100%;
    padding-right: 100px;

    &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    color: #f0f8ff;
    font-size: ${props => (props.lang === 'en' ? '14px' : '16px')};
    }
    ::-moz-placeholder { /* Firefox 19+ */
    color: #f0f8ff;
    font-size: ${props => (props.lang === 'en' ? '14px' : '16px')};  
    }
    :-ms-input-placeholder { /* IE 10+ */
    color: #f0f8ff;
    font-size: ${props => (props.lang === 'en' ? '14px' : '16px')};
    }
    :-moz-placeholder { /* Firefox 18- */
    color: #f0f8ff;
    font-size: ${props => (props.lang === 'en' ? '14px' : '16px')};      
    }
  }

  .actions {
    display: flex;
    align-items: center;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);

    > div {
      &:first-child {
        margin-right: 24px;
      }
    }
  }
`;

const SearchMobile = styled.div`

    @media screen and (min-width: 768px){
      display: none;
    }

  .search-toggle {
    margin-right: 12px;
    cursor: pointer;
    img {
      display: inline-block;
      vertical-align: middle;
    }
  }
  

  .search-input{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    cursor: pointer;
    display: none;
    z-index: 9;

    &.is-active{
      display: block;
    } 

    input{
    background-image: url('${props => props.icon}');
    background-size: 16px;
    height: 64px;
    background-color: #fff;
    color: #4a4a4a;
    font-size: 14px;
    line-height: 22px;
    text-indent: 42px;
    background-repeat: no-repeat;
    background-position: 20px center;
    border: 1px solid #f0f8ff;
    outline: none;
    width: 100%;
    padding-right: 40px

    &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    color: #4a4a4a;
    font-size: 14px;
    }
    ::-moz-placeholder { /* Firefox 19+ */
      color: #4a4a4a;
    font-size: 14px;    
    }
    :-ms-input-placeholder { /* IE 10+ */
      color: #4a4a4a;
    font-size: 14px;    
    }
    :-moz-placeholder { /* Firefox 18- */
      color: #4a4a4a;
    font-size: 14px;    
    }
    }
  }

`;

const CloseIcon = styled.div`
  color: ${props => (props.light ? '#fff' : props.theme.primary.ujyaalo)};
  position: absolute;
  margin-top: 0;
  margin-left: 0;
  width: 18px;
  height: 18px;
  right: ${props => (props.light ? '70px' : '18px')};
  cursor: pointer;

  top: 50%;
  transform: translateY(-50%);

  &:before {
    content: '';
    position: absolute;
    top: 10px;
    width: 18px;
    height: 1px;
    background-color: currentColor;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  &:after {
    content: '';
    position: absolute;
    top: 10px;
    width: 18px;
    height: 1px;
    background-color: currentColor;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;



// WEBPACK FOOTER //
// ./src/components/layouts/navbar/search.js